import Swiper from 'swiper/bundle';
// import 'swiper/css/bundle';

import VideoPlayers from "./videoPlayers";

export default class SwiperSliders {
    constructor() {
        this.videoPlayers = new VideoPlayers();
        this.init();
    }

    init() {
        this.initSwiperCarousel1();
        this.initSwiperCarousel2();
        this.initSwiperCarousel3();
        this.initSwiperCarousel5();

        this.initSwiperListing5();

        this.initSwiperTestimonials1();
        this.initSwiperTestimonials2();
        this.initSwiperTestimonials4();

        this.initSwiperPosts1();
        this.initSwiperContent2Carousel();
    }

    // === SWIPER CAROUSEL 1 ===
    initSwiperCarousel1() {
        document.querySelectorAll('.swiperCarousel-1').forEach((el) => {
            const block = el.closest('.block-carousel-1');
            new Swiper(el, {
                grabCursor: true,
                slidesPerView: 1.125,
                spaceBetween: 14,
                breakpoints: {
                    768: {
                        slidesPerView: 2.125,
                    },
                    1024: {
                        slidesPerView: 3.125,
                    },
                },
                navigation: {
                    prevEl: block ? block.querySelector('.swiper-navigation .swiper-prev') : null,
                    nextEl: block ? block.querySelector('.swiper-navigation .swiper-next') : null,
                },
            });
        });
    }

    // === SWIPER CAROUSEL 2 ===
    initSwiperCarousel2() {
        document.querySelectorAll('.swiperCarousel-2').forEach((el) => {
            const block = el.closest('.block-carousel-2');
            new Swiper(el, {
                grabCursor: true,
                slidesPerView: 1.125,
                spaceBetween: 14,
                breakpoints: {
                    768: {
                        slidesPerView: 2.25,
                    },
                    1024: {
                        slidesPerView: 3.125,
                    },
                    1200: {
                        slidesPerView: 3.5,
                    },
                },
                navigation: {
                    prevEl: block ? block.querySelector('.swiper-navigation .swiper-prev') : null,
                    nextEl: block ? block.querySelector('.swiper-navigation .swiper-next') : null,
                },
            });
        });
    }

    // === SWIPER CAROUSEL 3 ===
    initSwiperCarousel3() {
        document.querySelectorAll('.swiperCarousel-3').forEach((el) => {
            const block = el.closest('.block-carousel-3');
            new Swiper(el, {
                grabCursor: true,
                slidesPerView: "auto",
                centeredSlides: true,
                spaceBetween: 14,
                loop: true,
                navigation: {
                    prevEl: block ? block.querySelector('.swiper-navigation .swiper-prev') : null,
                    nextEl: block ? block.querySelector('.swiper-navigation .swiper-next') : null,
                },
                on: {
                    slideChange: () => {
                        this.pauseCurrentVideo();
                    }
                }
            });
        });
    }

    // === SWIPER CAROUSEL 5 ===
    initSwiperCarousel5() {
        document.querySelectorAll('.swiperCarousel-5').forEach((el) => {
            const block = el.closest('.block-carousel-5');
            new Swiper(el, {
                grabCursor: true,
                slidesPerView: 1,
                spaceBetween: 14,
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 3,
                    },
                },
                navigation: {
                    prevEl: block ? block.querySelector('.swiper-navigation .swiper-prev') : null,
                    nextEl: block ? block.querySelector('.swiper-navigation .swiper-next') : null,
                },
            });
        });
    }

    // === SWIPER LISTING 5 ===
    initSwiperListing5() {
        document.querySelectorAll('.swiperListing-5').forEach((el) => {
            const block = el.closest('.block-listing-5');
            new Swiper(el, {
                grabCursor: true,
                slidesPerView: 'auto',
                spaceBetween: 14,
                loop: true,
                breakpoints: {
                    768: {
                        spaceBetween: 20,
                    },
                    1024: {
                        spaceBetween: 40,
                    },
                },
                navigation: {
                    prevEl: block ? block.querySelector('.swiper-navigation .swiper-prev') : null,
                    nextEl: block ? block.querySelector('.swiper-navigation .swiper-next') : null,
                },
            });
        });
    }


    // === SWIPER TESTIMONIALS 1 ===
    initSwiperTestimonials1() {
        document.querySelectorAll('.swiperTestimonials-1').forEach((el) => {
            const block = el.closest('.block-testimonials-1');

            const onOver = (e) => { if (e.target.closest('.swiper-slide')) el.classList.add('is-hovering'); };
            const onLeave = () => el.classList.remove('is-hovering');
            const onFocusIn = () => el.classList.add('is-focusing');
            const onFocusOut = () => el.classList.remove('is-focusing');

            el.addEventListener('mouseover', onOver);
            el.addEventListener('mouseleave', onLeave);
            el.addEventListener('focusin', onFocusIn);
            el.addEventListener('focusout', onFocusOut);

            new Swiper(el, {
                grabCursor: true,
                slidesPerView: 1,
                spaceBetween: 14,
                centeredSlides: false,
                maxBackfaceHiddenSlides: 5,
                loop: false,
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                    },
                    1200: {
                        slidesPerView: 3,
                    },
                },
                navigation: {
                    prevEl: block ? block.querySelector('.swiper-navigation .swiper-prev') : null,
                    nextEl: block ? block.querySelector('.swiper-navigation .swiper-next') : null,
                },
                on: {
                    slideChangeTransitionStart: () => this.pauseCurrentVideo(),
                    slideChange: () => this.pauseCurrentVideo(),
                    beforeDestroy: () => this.pauseCurrentVideo(),
                },
            });
        });
    }

    // === SWIPER TESTIMONIALS 2 ===
    initSwiperTestimonials2() {
        document.querySelectorAll('.swiperTestimonials-2').forEach((el) => {
            const block = el.closest('.block-testimonials-2');
            new Swiper(el, {
                grabCursor: true,
                slidesPerView:"auto",
                spaceBetween: 14,
                centeredSlides: true,
                loop: true,
                breakpoints: {
                    768: {
                        spaceBetween: 20
                    },
                    1024: {
                        spaceBetween: 40
                    },
                    1200: {
                        spaceBetween: 80
                    },
                },
                navigation: {
                    prevEl: block ? block.querySelector('.swiper-navigation .swiper-prev') : null,
                    nextEl: block ? block.querySelector('.swiper-navigation .swiper-next') : null,
                },
            });
        });
    }

    // === SWIPER TESTIMONIALS 4 ===
    initSwiperTestimonials4() {
        document.querySelectorAll('.block-testimonials-4').forEach((block) => {
            const textEl = block.querySelector('.swiperTestimonials-4-text');
            const mediaEl = block.querySelector('.swiperTestimonials-4-media');
            const paginationEl = block.querySelector('.swiper-pagination-numeric');

            if (!textEl || !mediaEl) return;

            const mediaSwiper = new Swiper(mediaEl, {
                slidesPerView: 1,
                effect: "fade",
                loop: true,
                watchSlidesProgress: true,
                grabCursor: true,
                allowTouchMove: false,
                simulateTouch: false,
                on: {
                    slideChange: () => {
                        this.pauseCurrentVideo();
                    }
                }
            });

            const textSwiper = new Swiper(textEl, {
                slidesPerView: 1,
                effect: "fade",
                loop: true,
                grabCursor: true,
                navigation: {
                    nextEl: block.querySelector('.swiper-navigation .swiper-next'),
                    prevEl: block.querySelector('.swiper-navigation .swiper-prev'),
                },
                thumbs: {
                    swiper: mediaSwiper,
                },
            });

            if (paginationEl) {
                const totalSlides = parseInt(paginationEl.getAttribute('data-total-slides'), 10);

                function updatePagination() {
                    const currentIndex = textSwiper.realIndex + 1;
                    paginationEl.textContent = `${currentIndex} / ${totalSlides}`;
                }

                textSwiper.on('init', updatePagination);
                textSwiper.on('slideChange', updatePagination);
            }
        });
    }

    // === SWIPER POSTS 1 ===
    initSwiperPosts1() {
        document.querySelectorAll('.swiperPosts-1').forEach((el) => {
            const block = el.closest('.block-posts-1');
            new Swiper(el, {
                grabCursor: true,
                slidesPerView: 1,
                spaceBetween: 14,
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 2.5
                    },
                    1200: {
                        slidesPerView: 3,
                    },
                },
                navigation: {
                    prevEl: block ? block.querySelector('.swiper-navigation .swiper-prev') : null,
                    nextEl: block ? block.querySelector('.swiper-navigation .swiper-next') : null,
                },
            });
        });
    }

    // === SWIPER CONTENT 2 CAROUSEL ===
    initSwiperContent2Carousel() {
        document.querySelectorAll('.block-content-2-carousel-actifdigital').forEach((block) => {
            const mediaEl = block.querySelector('.swiperContent2Carousel-media');
            const contentEl = block.querySelector('.swiperContent2Carousel-content');

            let mediaSwiperInstance = null;

            if (mediaEl) {
                mediaSwiperInstance = new Swiper(mediaEl, {
                    loop: false,
                    spaceBetween: 0,
                    allowTouchMove: false,
                    simulateTouch: false,
                    watchSlidesProgress: true,
                    effect: "creative",
                    creativeEffect: {
                        prev: {
                            shadow: true,
                            translate: ["-20%", 0, -1],
                        },
                        next: {
                            translate: ["100%", 0, 0],
                        },
                    },
                });
            }

            if (contentEl) {
                const contentSwiper = new Swiper(contentEl, {
                    loop: false,
                    spaceBetween: 0,
                    effect: "fade",
                    autoHeight: true,
                    navigation: {
                        prevEl: block.querySelector('.swiper-navigation .swiper-prev'),
                        nextEl: block.querySelector('.swiper-navigation .swiper-next'),
                    },
                    breakpoints: {
                        768: {
                            autoHeight: false,
                        }
                    },
                    on: {
                        slideChange: (swiper) => {
                            if (mediaSwiperInstance) {
                                mediaSwiperInstance.slideTo(swiper.activeIndex);
                            }
                        },
                    },
                });
            }
        });
    }

    pauseCurrentVideo = () => {
        if (this.videoPlayers) {
            this.videoPlayers.pauseAllPlayers();
        }
    };

}
